module.exports = __webpack_public_path__ + "assets/images/icons/icon_vaccine-red.svg?v=ded6b160";